<script lang="ts">
    
    import { gamesService } from "../../Services";

    export let managerId: string;

    $: gamesCount = gamesService.getEndedGamesCount(managerId);

</script>

{#await gamesCount}
    Cargando...
{:then count} 
    <slot {count}>{count}</slot>
{/await}
